import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "messages__avatar" }
const _hoisted_3 = { class: "messages" }
const _hoisted_4 = {
  class: "messages__author",
  "aria-level": "4"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_AvatarWrapper = _resolveComponent("AvatarWrapper")
  const _component_MessageItem = _resolveComponent("MessageItem")

  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_AvatarWrapper, {
        id: $options.actorId,
        token: $props.token,
        name: $setup.actorDisplayName,
        source: $options.actorType,
        size: $setup.AVATAR.SIZE.SMALL,
        "disable-menu": $options.disableMenu,
        "disable-tooltip": ""
      }, null, 8, ["id", "token", "name", "source", "size", "disable-menu"])
    ]),
    _createElementVNode("ul", _hoisted_3, [
      _createElementVNode("li", _hoisted_4, _toDisplayString($setup.actorInfo), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.messages, (message, index) => {
        return (_openBlock(), _createBlock(_component_MessageItem, {
          key: message.id,
          message: message,
          "next-message-id": ($props.messages[index + 1] && $props.messages[index + 1].id) || $props.nextMessageId,
          "previous-message-id": (index > 0 && $props.messages[index - 1].id) || $props.previousMessageId
        }, null, 8, ["message", "next-message-id", "previous-message-id"]))
      }), 128))
    ])
  ]))
}